import { render, staticRenderFns } from "./CaseHeader.vue?vue&type=template&id=10a2926b&"
import script from "./CaseHeader.vue?vue&type=script&lang=js&"
export * from "./CaseHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports